import accountingApi from '../_api'

export default {
  fetchAccountingPeriods: async ({ getters, commit, dispatch }) => {
    if (getters.isCallingAccounting) return
    commit('setIsCallingAccounting', true)

    try {
      const response = await accountingApi.getAccountingPeriods()
      commit('setAccountingPeriods', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'accounting_action_fetch_accounting_periods_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingAccounting', false)
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
